import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  position: relative;
  display: block;
`;

// &&: doubles the generated class selector (.cls.cls) raising specificity from
// 0,1,0 to 0,2,0 — enough to beat host-page rules like input[type=checkbox] (0,1,1)
// that would otherwise override position/size and break the invisible click overlay.
export const HiddenCheckbox = styled.input`
  && {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    cursor: pointer;
    z-index: 2;
  }

  /* Keyboard focus styles */
  &&:focus-visible + div {
    outline: 2px solid -webkit-focus-ring-color;
    outline-offset: 2px;
    border-radius: 2px;
  }

  /* Remove default focus ring */
  &&:focus {
    outline: none;
  }

  /* Disabled state */
  &&:disabled {
    cursor: not-allowed;
  }

  &&:disabled ~ div {
    opacity: 0.5;
  }
`;

export const IconWrapper = styled.div`
  z-index: 1;
  width: fit-content;
  height: fit-content;

  svg {
    width: 18px;
    height: 18px;
    display: block;
  }
`;
